import {
  companyFormFields,
  planFormFields,
  eligibilityFormFields,
  payrollFormFields,
  censusFormFields,
  maintenanceFormFields,
  reportsFormFields,
  communicationFormFields,
  tradeFormFields,
  transactionFormFields,
  rkaasFormFields,
  feeFormFields,
  mapperFormFields,
  vestingFormFields,
} from "./";

export * from "./common";
export * from "./company";
export * from "./plan";
export * from "./eligibility";
export * from "./employee";
export * from "./payroll";
export * from "./maintenance";
export * from "./reports";
export * from "./enrollment";
export * from "./mapper";
export * from "./docoCenter";
export * from "./doco";
export * from "./communication";
export * from "./forfeiture";
export * from "./trade";
export * from "./distribution";
export * from "./transaction";
export * from "./masters";
export * from "./rkaas";
export * from "./fee";
export const formFields = {
  ...companyFormFields,
  ...planFormFields,
  ...eligibilityFormFields,
  ...censusFormFields,
  ...payrollFormFields,
  ...maintenanceFormFields,
  ...reportsFormFields,
  ...rkaasFormFields,
  ...mapperFormFields,
  ...communicationFormFields,
  ...tradeFormFields,
  ...transactionFormFields,
  ...feeFormFields,
  ...vestingFormFields,
};
